import { useParams } from "react-router-dom";

import { PadlockIcon } from "../icons";

import { useTranslationContext } from "context/TranslationContext";

const PermissionDenied = () => {
  const { t } = useTranslationContext();
  const { buSlug } = useParams();

  const handleClick = () => {
    window.location.href = `/${buSlug}`;
  };

  return (
    <div className="flex flex-col items-center justify-center bg-white -ml-8 -mr-8 -mt-8  h-[calc(100vh-6.85rem)]">
      <PadlockIcon />
      <h1 className="text-hsBlue-500 text-2xl font-bold mt-5 mb-3">
        {t("access_denied")}
      </h1>
      <p className="text-lg text-[#404040]">{t("access_denied.message1")}</p>
      <p className="text-lg text-[#404040]">{t("access_denied.message2")}</p>
      <button
        onClick={handleClick}
        className="mt-8 py-3 px-12 text-white bg-dodgerBlue-500 rounded-lg text-base"
      >
        {t("go_to_home")}
      </button>
    </div>
  );
};

export default PermissionDenied;
